import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import { CardBase, StackBase, TypographyBase, ButtonBase } from '@fmc-digital/ui';
import { Container, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { error_animation } from './ErrorAnimation';
import { useHomeContext } from '@components_v2/context/MyHomeContext';
import { config } from '../../../config';
import i18next from 'i18next';

// Error page - props
// text, subText, title, subtitle

export const ErrorPage = () => {
    const _theme = useTheme();
    const navigate = useNavigate();
    const { state } = useLocation();
    const style = {
        width: '12.5rem',
        height: '12.5rem'
    };

    const genericTitle = 'Oops!';
    const genericSubTitle = 'Something went wrong on our end.';

    return (
        <Container maxWidth="sm" sx={{ padding: _theme.spacing(4), maxWidth: { xs: '100%', sm: '47rem', xl: '50.125rem' } }}>
            <StackBase
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: _theme.spacing(4)
                }}
            >
                <CardBase
                    sx={{
                        boxShadow: '0px 4px 8px 0px rgba(18, 32, 44, 0.10)'
                    }}
                >
                    <StackBase alignItems="center">
                        <Lottie animationData={error_animation} loop autoplay style={style} />
                        <TypographyBase variant="alt-title1" sx={{ textAlign: 'center', marginBottom: '1rem' }}>
                            {state?.title || genericTitle}
                        </TypographyBase>
                        <TypographyBase variant="alt-subtitle1" sx={{ textAlign: 'center' }}>
                            {i18next.t(state?.subtitle) || genericSubTitle}
                        </TypographyBase>

                        <TypographyBase
                            variant="paragraph"
                            color={_theme.palette.neutrals[400]}
                            sx={{ textAlign: 'center', marginTop: '2rem', whiteSpace: 'break-spaces' }}
                        >
                            {state?.text || 'We apologize for the inconvenience. We are working to resolve the issue on our end.'}
                        </TypographyBase>
                    </StackBase>
                </CardBase>
                <StackBase justifyContent="center" alignItems="center" display="flex" gap={_theme.spacing(4)}>
                    <TypographyBase variant="paragraph" textAlign={'center'} color="#536371">
                        {state?.subText || 'Please try again later.'}
                    </TypographyBase>
                    <ButtonBase
                        color="primary"
                        variant="contained"
                        onClick={() => {
                            navigate('/', { preventScrollReset: true });
                        }}
                    >
                        Return To Home
                    </ButtonBase>
                </StackBase>
            </StackBase>
        </Container>
    );
};
